import {Col, Form, Input} from 'antd'
import React from 'react'
import {get} from 'lodash'
import AccountsTreeSelect from '../../../elements/TreeSelect/AccountsTreeSelect'
import * as PropTypes from 'prop-types'
import {
  defaultFormItemLayout,
  fullWidthFormItemLayout,
  rules,
} from '../../../modules/FormItems'
import EmployeeSelect from '../../../elements/Select/Employee/EmployeesSelect'

function CenterForm(props) {
  const {getFieldDecorator} = props.form
  const {center} = props
  return (
    <Form>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={'Name'}>
          {getFieldDecorator('name', {
            initialValue: get(center, 'name'),
            rules: rules.input,
          })(<Input placeholder={'Name'} />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={'ID'}>
          {getFieldDecorator('ID')(<span>{get(center, '_key')}</span>)}
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item {...fullWidthFormItemLayout} label={'Account'}>
          {getFieldDecorator('accounts', {
            initialValue: get(center, 'accounts'),
          })(<AccountsTreeSelect center={center} placeholder={'Account'} />)}
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item {...fullWidthFormItemLayout} label={'Manager'}>
          {getFieldDecorator('manager._id', {
            initialValue: get(center, 'manager._id'),
          })(<EmployeeSelect placeholder={'Manager'} />)}
        </Form.Item>
      </Col>
    </Form>
  )
}

CenterForm.propTypes = {
  center: PropTypes.any,
}
export default Form.create()(CenterForm)
